import type { FaireProductEntity } from "../../entity_types/product";

export const p_dxmqwdn83h: FaireProductEntity = {
  token: "p_dxmqwdn83h",
  type: "product",
  name: "Crystal Goddess",
  brandToken: "b_8h5sk43qpz",
  brandName: "Down To Earth",
  imageUrl:
    "https://cdn.faire.com/fastly/4c3d7890b88f03b58e19c1fd6432238a0a895e89620bb62b005664698c74f055.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5c85e109a939adda4fc88a6871d6e14e18cea92454a23bc4098a2fc276d9db99.jpeg",
    "https://cdn.faire.com/fastly/9c14922b96b38df52c35e73c7dce4834037694fdac548f9c26445ce0affb370b.jpeg",
    "https://cdn.faire.com/fastly/0b05c8428e5edac1e05ae11f713677fecb1cc2f078e4b7ecde3ad692fc1de248.jpeg",
    "https://cdn.faire.com/fastly/6bb01a06d8a077beb2ca643f7a075d142cc814ee5601984ad5de52bb737b57f6.jpeg",
    "https://cdn.faire.com/fastly/6fb0c1c594b8f02183efd8f05b5d491cd60fb33b6f30b265bcd8f84914367398.jpeg",
    "https://cdn.faire.com/fastly/416c896b8bfeec13facb12b3602414974e5b3c9547dac53ccdb1ad436750d314.jpeg",
    "https://cdn.faire.com/fastly/87e5a08e14f29927afc4fd94afb36eaf5c65bdaeff42829285d27086bd86e23d.jpeg",
    "https://cdn.faire.com/fastly/c3da1c231a4ac03272e05716f847495be28b4acbde9c1c8de0e04b0fa65b475c.jpeg",
    "https://cdn.faire.com/fastly/9fc25c8ef120f39da690e6d227925a624adb285d74925b9f6ad820fb8d4e65e7.jpeg",
    "https://cdn.faire.com/fastly/8cda52143e9468ea8900de5f386044929711f163459b5c057b134fe9dfa85d44.jpeg",
    "https://cdn.faire.com/fastly/fc5fc5808edd09951e0100cfffc6aef5d905c03b305ca84f3a5b6350ce3e3883.jpeg",
    "https://cdn.faire.com/fastly/39185b262e244aff38bdb65e1b269d98f915f90725065e354145c0edbaeb571e.jpeg",
    "https://cdn.faire.com/fastly/afbb5d60c82f5827dce8611ece03e9069b777cf1051ea5a0a6c61f9e94a48fda.jpeg",
    "https://cdn.faire.com/fastly/cb67b570fd9851d28160d970ef914c1ec20b0093e3666cab64d483f475eee764.jpeg",
  ],
  priceDollars: 15,
  description:
    'Infuse your surroundings and sacred self-care routines with the essence of the Divine Feminine by incorporating one of these beautifully hand-carved Crystal Goddesses. These figurines showcase the Spiral of Life symbol etched onto their bellies, embodying feminine qualities like beauty, love, sensuality, motherhood, and fertility.\n\nA Crystal Goddess serves not only as a charming ornament but also as a beneficial fertility crystal and a companion stone on your path to motherhood. Elevate your crystal grids by placing a Spiral Goddess at the focal point, surrounded by nurturing stones that resonate with themes of love, womb healing, creativity, relationships, and abundance.\n\nApprox. 2.25"-3.25"\n',
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:51.872Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
